import * as yup from 'yup'

export const schemaCreateSampleContractModal = yup.object().shape({
    contract_number_id: yup.string().required(),
    contract_key: yup.string().required(),
    contract_effective_date: yup.string().required(),
    contract_type: yup.string().required(),
})
